import {
    IonCard,
    IonCardHeader,
    IonContent,
    IonPage,
    IonRow,
} from '@ionic/react';
import { Trans } from '@lingui/macro';
import React from 'react';

import classes from '../pages/Login.module.css';
import Logo from './logo/Logo';

const NotFound = () => {
    return (
        <IonPage>
            <IonContent className={classes.LoginContent}>
                <IonCard>
                    <IonCardHeader>
                        <IonRow className="ion-justify-content-center">
                            <Logo />
                        </IonRow>
                        <IonRow className="ion-justify-content-center">
                            <h5>
                                <Trans>Oops, this page is not found.</Trans>
                            </h5>
                        </IonRow>
                        <IonRow className="ion-justify-content-center">
                            <h5>
                                <a href="/">
                                    <Trans>Go back</Trans>
                                </a>
                            </h5>
                        </IonRow>
                    </IonCardHeader>
                </IonCard>
            </IonContent>
        </IonPage>
    );
};

export default NotFound;
